<div class="page">

  @if (loading()) {
    <div class="state">Carregando...</div>
  } @else if (!cupom()) {
    <div class="alert alert--erro">Cupom nao encontrado.</div>
  } @else {

    <!-- EYEBROW + ACTIONS -->
    <div class="top-bar">
      <span class="top-bar__eyebrow">Conferencia de cupom</span>
      <div class="top-bar__actions">
        @if (!editando()) {
          <button class="btn" (click)="iniciarEdicao()">Editar</button>
        }
        @if (cupom()!.ieSituacao === 'A') {
          <button class="btn btn--ghost-danger" (click)="inativar()" [disabled]="salvando()">Inativar</button>
        }
        <button class="btn" (click)="voltar()">Voltar</button>
      </div>
    </div>

    <!-- TICKET HERO -->
    <div class="ticket">
      <div class="ticket__inner">
        <div class="ticket__top">
          <!-- Marca anterior: <span class="ticket__brand">SIMCARE &middot; CUPOM #{{ cupom()!.nrSequencia.toString().padStart(6, '0') }}</span> -->
          <span class="ticket__brand">FLUA &middot; CUPOM #{{ cupom()!.nrSequencia.toString().padStart(6, '0') }}</span>
          <span class="ticket__sit" [class.ticket__sit--ativo]="cupom()!.ieSituacao === 'A'"
                [class.ticket__sit--inativo]="cupom()!.ieSituacao !== 'A'">
            {{ situacaoLabel() }}
          </span>
        </div>
        <div class="ticket__code">{{ cupom()!.codCupom }}</div>
        <div class="ticket__bottom">
          <span class="ticket__desc">{{ cupom()!.dsCupom }}</span>
          <span class="ticket__discount">{{ descontoLabel() }} OFF</span>
        </div>
      </div>
      <div class="ticket__notch ticket__notch--left"></div>
      <div class="ticket__notch ticket__notch--right"></div>
    </div>

    <!-- RESUMO TEXTO -->
    <p class="resumo">
      Cupom <strong>{{ tipoLabel() | lowercase }}</strong>
      @if (cupom()!.ieTipoDesconto === 'P' && cupom()!.prDesconto != null) {
        com desconto percentual de {{ cupom()!.prDesconto }}%
      } @else if (cupom()!.vlDesconto != null) {
        com desconto de {{ fmtR(cupom()!.vlDesconto!) }}
      } @else {
        tipo {{ tipoLabel() | lowercase }}
      }
      @if (cupom()!.dtVigenciaFim) {
        , vigencia ate {{ fmt(cupom()!.dtVigenciaFim!) }}
      } @else {
        , sem prazo final
      }
      , limite de {{ cupom()!.qtUsoMaxPessoa ?? 1 }} uso por pessoa.
      @if (cupom()!.vlTeto != null) {
        Teto de {{ fmtR(cupom()!.vlTeto!) }}.
      }
    </p>

    <!-- TABS -->
    <nav class="tabs">
      <button class="tabs__btn" [class.tabs__btn--active]="tab() === 'cadastro'" (click)="tab.set('cadastro')">Cadastro</button>
      <button class="tabs__btn" [class.tabs__btn--active]="tab() === 'uso'" (click)="tab.set('uso')">Uso</button>
    </nav>

    <!-- ========== ABA USO ========== -->
    @if (tab() === 'uso') {

      @if (!stats()) {
        <div class="state">Carregando estatisticas...</div>
      } @else {

        <!-- APLICACOES TOTAIS -->
        <span class="section-label">Aplicacoes totais</span>

        <div class="uso-hero">
          <div class="uso-hero__left">
            <span class="uso-hero__big">{{ stats()!.totalUsados.toLocaleString('pt-BR') }}</span>
            @if (stats()!.totalEmitidos > 0) {
              <span class="uso-hero__taxa">{{ (stats()!.totalUsados / stats()!.totalEmitidos * 100).toFixed(0) }}% conversao</span>
            }
          </div>
          <div class="uso-hero__right">
            <div class="metric-card">
              <div class="metric-card__item">
                <span class="metric-card__label">Descontado</span>
                <span class="metric-card__value">{{ fmtR(stats()!.totalDescontado) }}</span>
              </div>
              <div class="metric-card__item">
                <span class="metric-card__label">Ticket medio</span>
                <span class="metric-card__value">{{ stats()!.totalUsados > 0 ? fmtR(stats()!.totalDescontado / stats()!.totalUsados) : 'R$ 0' }}</span>
                <span class="metric-card__sub">por aplicacao</span>
              </div>
              <div class="metric-card__item">
                <span class="metric-card__label">Pacientes</span>
                <span class="metric-card__value">{{ stats()!.totalPacientesUnicos.toLocaleString('pt-BR') }}</span>
                <span class="metric-card__sub">unicos</span>
              </div>
            </div>
          </div>
        </div>

        <!-- STATUS BREAKDOWN -->
        <div class="status-bar">
          @if (stats()!.totalEmitidos > 0) {
            <div class="status-bar__seg status-bar__seg--usado"
                 [style.flex]="stats()!.totalUsados"></div>
            <div class="status-bar__seg status-bar__seg--disponivel"
                 [style.flex]="stats()!.totalDisponiveis"></div>
            <div class="status-bar__seg status-bar__seg--expirado"
                 [style.flex]="stats()!.totalExpirados"></div>
          }
        </div>
        <div class="status-legend">
          <span class="status-legend__item"><span class="status-legend__dot status-legend__dot--usado"></span> {{ stats()!.totalUsados }} usados</span>
          <span class="status-legend__item"><span class="status-legend__dot status-legend__dot--disponivel"></span> {{ stats()!.totalDisponiveis }} disponiveis</span>
          <span class="status-legend__item"><span class="status-legend__dot status-legend__dot--expirado"></span> {{ stats()!.totalExpirados }} expirados</span>
        </div>

        <!-- POR UNIDADE + REGRAS CONFIGURADAS -->
        <div class="duo-grid">

          <!-- POR UNIDADE -->
          <div class="panel">
            <h2 class="panel__title">Por unidade</h2>
            @if (stats()!.porUnidade.length > 0) {
              <p class="panel__sub">{{ stats()!.porUnidade.length }} unidades aplicaram este cupom</p>
              <div class="unit-list">
                @for (u of stats()!.porUnidade; track u.cdEstabelecimento) {
                  <div class="unit-item">
                    <div class="unit-item__row">
                      <span class="unit-item__name">{{ u.dsEstabelecimento }}</span>
                      <span class="unit-item__nums"><strong>{{ u.totalUsos.toLocaleString('pt-BR') }}</strong> · {{ fmtR(u.totalDescontado) }}</span>
                    </div>
                    <div class="unit-item__bar">
                      <div class="unit-item__fill" [style.width.%]="stats()!.porUnidade[0].totalUsos > 0 ? (u.totalUsos / stats()!.porUnidade[0].totalUsos * 100) : 0"></div>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="empty-state">Nenhuma aplicacao registrada.</div>
            }
          </div>

          <!-- REGRAS CONFIGURADAS -->
          <div class="panel">
            <h2 class="panel__title">Regras configuradas</h2>
            <p class="panel__sub">O que precisa ser verdade para o cupom ser aplicavel</p>
            <div class="rule-list">
              <div class="rule-item">
                <span class="rule-icon rule-icon--ok"></span>
                <div>
                  <strong>Vigencia</strong>
                  <span>{{ vigenciaRegraLabel() }}</span>
                </div>
              </div>
              <div class="rule-item">
                <span class="rule-icon rule-icon--ok"></span>
                <div>
                  <strong>Tipo do cupom</strong>
                  <span>{{ tipoRegraLabel() }}</span>
                </div>
              </div>
              <div class="rule-item" [class.rule-item--inactive]="regras().length === 0">
                <span class="rule-icon" [class.rule-icon--ok]="regras().length > 0" [class.rule-icon--off]="regras().length === 0"></span>
                <div>
                  <strong>Procedimentos elegiveis</strong>
                  <span>{{ procedimentosRegraLabel() }}</span>
                </div>
              </div>
              <div class="rule-item">
                <span class="rule-icon rule-icon--ok"></span>
                <div>
                  <strong>Limite por pessoa</strong>
                  <span>{{ limiteRegraLabel() }}</span>
                </div>
              </div>
              <div class="rule-item" [class.rule-item--inactive]="regrasPlano().length === 0 && regrasEmpresa().length === 0 && regrasEstab().length === 0">
                <span class="rule-icon" [class.rule-icon--ok]="regrasPlano().length > 0 || regrasEmpresa().length > 0 || regrasEstab().length > 0" [class.rule-icon--off]="regrasPlano().length === 0 && regrasEmpresa().length === 0 && regrasEstab().length === 0"></span>
                <div>
                  <strong>Filtros adicionais</strong>
                  <span>{{ filtrosRegraLabel() }}</span>
                </div>
              </div>
              <div class="rule-item" [class.rule-item--inactive]="combos().length === 0 && dependencias().length === 0">
                <span class="rule-icon" [class.rule-icon--ok]="combos().length > 0 || dependencias().length > 0" [class.rule-icon--off]="combos().length === 0 && dependencias().length === 0"></span>
                <div>
                  <strong>Combo / dependencias</strong>
                  <span>{{ comboRegraLabel() }}</span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- HISTORICO DE APLICACOES -->
        @if (aplicacoes().length > 0) {
          <div class="hist-header">
            <h2 class="panel__title">Historico de aplicacoes</h2>
          </div>
          <div class="panel">
            <table class="tbl">
              <thead>
                <tr>
                  <th>Quando</th>
                  <th>Paciente</th>
                  <th>Unidade</th>
                  <th style="width:120px">Valor</th>
                  <th style="width:120px">Operador</th>
                </tr>
              </thead>
              <tbody>
                @for (a of aplicacoes(); track a.nrSequencia) {
                  <tr>
                    <td class="hist-quando">{{ tempoRelativo(a.dtUso) }}</td>
                    <td class="td-desc">{{ abreviarNome(a.nmPaciente) }}</td>
                    <td>{{ a.dsEstabelecimento }}</td>
                    <td class="num hist-valor">{{ fmtR(a.vlDescontoAplicado) }}</td>
                    <td class="hist-operador">{{ a.nmOperador }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }

      }
    }

    <!-- ========== ABA CADASTRO ========== -->
    @if (tab() === 'cadastro') {

      @if (editando()) {
        <div class="panel">
          <div class="panel__header"><h2 class="panel__title">Editar dados</h2></div>
          <div class="edit-form">
            <div class="edit-row">
              <label class="fld fld--grow"><span>Codigo</span><input type="text" [(ngModel)]="editForm.codCupom" /></label>
              <label class="fld fld--grow"><span>Descricao</span><input type="text" [(ngModel)]="editForm.dsCupom" /></label>
            </div>
            <div class="edit-row">
              <label class="fld fld--grow"><span>Observacao</span><input type="text" [(ngModel)]="editForm.dsObservacao" placeholder="Opcional" /></label>
            </div>
            <label class="check-row">
              <input type="checkbox" [(ngModel)]="editForm.ieEmissaoManual" />
              <span class="check-row__text">
                <strong>Cupom de emissão manual</strong>
                <small>Só aparece na opção de conceder manualmente na Conferência por CPF (retenção/PEP).</small>
              </span>
            </label>
            <div class="edit-row">
              <label class="fld"><span>Tipo</span>
                <select [(ngModel)]="editForm.ieTipo">
                  <option value="P">Todos</option><option value="C">B2C</option>
                  <option value="E">Empresa</option><option value="A">Assinantes</option><option value="G">Geral</option>
                </select></label>
              <label class="fld"><span>Tipo desconto</span>
                <select [(ngModel)]="editForm.ieTipoDesconto">
                  <option value="P">Percentual</option><option value="F">Preco fixo</option>
                  <option value="R">Real fixo</option><option value="V">Voucher</option>
                </select></label>
              <label class="fld fld--num"><span>% Desconto</span><input type="number" [(ngModel)]="editForm.prDesconto" /></label>
              <label class="fld fld--num"><span>R$ Desconto</span><input type="number" [(ngModel)]="editForm.vlDesconto" /></label>
              <label class="fld fld--num"><span>Teto R$</span><input type="number" [(ngModel)]="editForm.vlTeto" /></label>
            </div>
            <div class="edit-row">
              <label class="fld fld--grow"><span>Beneficiario na assinatura</span>
                <select [(ngModel)]="editForm.ieBeneficiario">
                  <option value="T">Titular</option><option value="D">Dependente</option>
                  <option value="C">Compartilhado</option><option value="I">Individual</option>
                </select></label>
            </div>
            <div class="edit-row">
              <label class="fld"><span>Inicio vigencia</span><input type="date" [(ngModel)]="editForm.dtVigenciaIni" /></label>
              <label class="fld"><span>Fim vigencia</span><input type="date" [(ngModel)]="editForm.dtVigenciaFim" /></label>
            </div>
            <div class="edit-row">
              <label class="fld fld--num"><span>Max usos global</span><input type="number" [(ngModel)]="editForm.qtUsoMaxGlobal" /></label>
              <label class="fld fld--num"><span>Por pessoa</span><input type="number" [(ngModel)]="editForm.qtUsoMaxPessoa" /></label>
              <label class="fld fld--num"><span>Bloqueio (dias)</span><input type="number" [(ngModel)]="editForm.nrDiasBloqueioReuso" /></label>
            </div>
            <div class="edit-actions">
              <button class="btn" (click)="cancelarEdicao()" [disabled]="salvando()">Cancelar</button>
              <button class="btn btn--primary" (click)="salvarEdicao()" [disabled]="salvando()">{{ salvando() ? 'Salvando...' : 'Salvar' }}</button>
            </div>
          </div>
        </div>
      }

      @if (cupom()!.dsObservacao && !editando()) {
        <div class="obs-box">
          <span class="obs-box__label">Observacao</span>
          <p class="obs-box__text">{{ cupom()!.dsObservacao }}</p>
        </div>
      }

      <!-- Regras de procedimento -->
      <section class="panel">
        <div class="panel__header"><h2 class="panel__title">Regras de procedimento</h2><span class="panel__count">{{ regras().length }}</span></div>
        @if (regras().length === 0) { <div class="empty-state">Nenhuma regra cadastrada.</div> }
        @else {
          <table class="tbl"><thead><tr><th>Tipo</th><th>Descricao</th><th>Modo</th><th style="width:80px"></th></tr></thead><tbody>
            @for (r of regras(); track r.nrSequencia) {
              <tr>
                <td><span class="tag" [class.tag--classif]="!!r.nrSeqClassif">{{ r.nrSeqClassif ? 'Classificacao' : 'Procedimento' }}</span></td>
                <td class="td-desc">{{ r.nrSeqClassif ? nomeClassif(r.nrSeqClassif) : r.cdProcedimento }}</td>
                <td><span class="modo" [class.modo--excl]="r.ieModo === 'E'">{{ r.ieModo === 'I' ? 'Incluir' : 'Excluir' }}</span></td>
                <td><button class="btn btn--sm btn--ghost-danger" (click)="excluirRegra(r.nrSequencia)" [disabled]="salvando()">Remover</button></td>
              </tr>
            }
          </tbody></table>
        }
        <div class="add-section"><div class="add-row">
          <label class="fld fld--grow"><span>Classificacao</span>
            <div class="ac">
              <input type="text" placeholder="Digite para filtrar a classificacao..." [ngModel]="classifBusca()" (ngModelChange)="classifBusca.set($event)" />
              @if (classifBusca().trim().length > 0) {
                @if (classifFiltradas().length > 0) {
                  <ul class="ac-list">
                    @for (c of classifFiltradas(); track c.nrSeqClassif) {
                      <li (click)="selecionarClassif(c)">{{ c.dsClassificacao }}</li>
                    }
                  </ul>
                } @else {
                  <ul class="ac-list"><li class="ac-empty">Nenhuma classificacao encontrada.</li></ul>
                }
              }
            </div></label>
        </div><div class="add-row">
          <label class="fld fld--grow"><span>Buscar procedimento</span>
            <input type="text" [ngModel]="buscaProc()" (ngModelChange)="onBuscaProcChange($event)" placeholder="Digite ao menos 2 letras..." /></label>
          @if (buscando()) { <span class="ac-loading">Buscando...</span> }
        </div>
        @if (resultadosBusca().length > 0) {
          <div class="results-box">@for (p of resultadosBusca(); track p.cdProcedimento) {
            <div class="result-item"><span class="result-item__cod">{{ p.cdProcedimento }}</span><span class="result-item__nome">{{ p.dsProcedimento }}</span><button class="btn btn--sm btn--primary" (click)="adicionarProcedimento(p)" [disabled]="salvando()">+</button></div>
          }</div>
        }</div>
      </section>

      <!-- Matriz de valor -->
      <section class="panel">
        <div class="panel__header"><h2 class="panel__title">Matriz de valor</h2><span class="panel__count">{{ faixas().length }}</span></div>
        @if (faixas().length === 0) { <div class="empty-state">Desconto padrao do cupom.</div> }
        @else {
          <table class="tbl"><thead><tr><th style="width:50px">#</th><th>Descricao</th><th>Desconto</th><th>Teto</th><th>Cartao SIM</th><th style="width:80px"></th></tr></thead><tbody>
            @for (f of faixas(); track f.nrSequencia) {
              <tr><td class="num">{{ f.nrOrdem }}</td><td class="td-desc">{{ f.dsRegra ?? '---' }}</td>
                <td>@if (f.prDesconto != null) { <span class="badge badge--pct">{{ f.prDesconto }}%</span> } @else { <span class="badge badge--val">R$ {{ f.vlFixo }}</span> }</td>
                <td>{{ f.vlTeto != null ? 'R$ ' + f.vlTeto : '---' }}</td>
                <td><span class="tag" [class.tag--sim]="f.ieExigeCartaoSim === 'S'">{{ f.ieExigeCartaoSim === 'S' ? 'Sim' : 'Nao' }}</span></td>
                <td><button class="btn btn--sm btn--ghost-danger" (click)="excluirFaixa(f.nrSequencia)" [disabled]="salvando()">Remover</button></td></tr>
            }
          </tbody></table>
        }
        <div class="add-section"><div class="add-row add-row--wrap">
          <label class="fld fld--grow"><span>Descricao</span><input type="text" [(ngModel)]="novaFaixaDesc" placeholder="Ex: Primeira consulta R$79" /></label>
          <label class="fld fld--num"><span>% Desconto</span><input type="number" [(ngModel)]="novaFaixaPr" /></label>
          <label class="fld fld--num"><span>R$ Fixo</span><input type="number" [(ngModel)]="novaFaixaVl" /></label>
          <label class="fld fld--num"><span>Teto R$</span><input type="number" [(ngModel)]="novaFaixaTeto" /></label>
          <button class="btn btn--primary btn--sm add-row__btn" (click)="adicionarFaixa()" [disabled]="salvando() || (!novaFaixaPr && !novaFaixaVl)">+ Faixa</button>
        </div></div>
      </section>

      <!-- Planos, Empresas, Estabelecimentos, Combos, Dependencias -->
      <section class="panel">
        <div class="panel__header"><h2 class="panel__title">Planos B2C</h2><span class="panel__count">{{ regrasPlano().length }}</span></div>
        @if (regrasPlano().length === 0) { <div class="empty-state">Sem restricao de plano.</div> } @else {
          <table class="tbl"><thead><tr><th>Plano</th><th>Modo</th><th style="width:80px"></th></tr></thead><tbody>
            @for (r of regrasPlano(); track r.nrSequencia) { <tr><td class="td-desc">{{ nomePlano(r.cdPlan) }}</td><td><span class="modo" [class.modo--excl]="r.ieModo === 'E'">{{ r.ieModo === 'I' ? 'Incluir' : 'Excluir' }}</span></td><td><button class="btn btn--sm btn--ghost-danger" (click)="excluirRegraPlano(r.nrSequencia)" [disabled]="salvando()">Remover</button></td></tr> }
          </tbody></table>
        }
        <div class="add-section"><div class="add-row">
          <label class="fld fld--grow"><span>Plano</span><select [ngModel]="planoSelecionado()" (ngModelChange)="planoSelecionado.set($event)"><option [ngValue]="null">Selecionar...</option>@for (p of planosB2c(); track p.cdPlano) { <option [ngValue]="p.cdPlano">{{ p.dsPlano }}</option> }</select></label>
          <button class="btn btn--primary btn--sm" (click)="adicionarRegraPlano()" [disabled]="planoSelecionado() == null || salvando()">+ Adicionar</button>
        </div></div>
      </section>

      <section class="panel">
        <div class="panel__header"><h2 class="panel__title">Empresas B2B</h2><span class="panel__count">{{ regrasEmpresa().length }}</span></div>
        @if (regrasEmpresa().length === 0) { <div class="empty-state">Sem restricao de empresa.</div> } @else {
          <table class="tbl"><thead><tr><th>Empresa</th><th>Modo</th><th style="width:80px"></th></tr></thead><tbody>
            @for (r of regrasEmpresa(); track r.nrSequencia) { <tr><td class="td-desc">{{ nomeEmpresa(r.cdEmpresa) }}</td><td><span class="modo" [class.modo--excl]="r.ieModo === 'E'">{{ r.ieModo === 'I' ? 'Incluir' : 'Excluir' }}</span></td><td><button class="btn btn--sm btn--ghost-danger" (click)="excluirRegraEmpresa(r.nrSequencia)" [disabled]="salvando()">Remover</button></td></tr> }
          </tbody></table>
        }
        <div class="add-section"><div class="add-row">
          <label class="fld fld--grow"><span>Empresa</span><select [ngModel]="empresaSelecionada()" (ngModelChange)="empresaSelecionada.set($event)"><option [ngValue]="null">Selecionar...</option>@for (e of empresas(); track e.cdEmpresa) { <option [ngValue]="e.cdEmpresa">{{ e.dsEmpresa }}</option> }</select></label>
          <button class="btn btn--primary btn--sm" (click)="adicionarRegraEmpresa()" [disabled]="empresaSelecionada() == null || salvando()">+ Adicionar</button>
        </div></div>
      </section>

      <section class="panel">
        <div class="panel__header"><h2 class="panel__title">Estabelecimentos</h2><span class="panel__count">{{ regrasEstab().length }}</span></div>
        @if (regrasEstab().length === 0) { <div class="empty-state">Sem restricao de unidade.</div> } @else {
          <table class="tbl"><thead><tr><th>Estabelecimento</th><th>Modo</th><th style="width:80px"></th></tr></thead><tbody>
            @for (r of regrasEstab(); track r.nrSequencia) { <tr><td class="td-desc">{{ nomeEstab(r.cdEstabelecimento) }}</td><td><span class="modo" [class.modo--excl]="r.ieModo === 'E'">{{ r.ieModo === 'I' ? 'Incluir' : 'Excluir' }}</span></td><td><button class="btn btn--sm btn--ghost-danger" (click)="excluirRegraEstab(r.nrSequencia)" [disabled]="salvando()">Remover</button></td></tr> }
          </tbody></table>
        }
        <div class="add-section"><div class="add-row">
          <label class="fld fld--grow"><span>Estabelecimento</span><select [ngModel]="estabSelecionado()" (ngModelChange)="estabSelecionado.set($event)"><option [ngValue]="null">Selecionar...</option>@for (e of estabelecimentos(); track e.cdEstabelecimento) { <option [ngValue]="e.cdEstabelecimento">{{ e.dsEstabelecimento }}</option> }</select></label>
          <button class="btn btn--primary btn--sm" (click)="adicionarRegraEstab()" [disabled]="estabSelecionado() == null || salvando()">+ Adicionar</button>
        </div></div>
      </section>

      @if (cupom()!.iePaiCombo === 'S') {
        <section class="panel">
          <div class="panel__header"><h2 class="panel__title">Cupons combo</h2><span class="panel__count">{{ combos().length }}</span></div>
          @if (combos().length === 0) { <div class="empty-state">Nenhum cupom-filho.</div> } @else {
            <table class="tbl"><thead><tr><th style="width:50px">#</th><th>Cupom filho</th><th>Offset (dias)<span class="info-tip" tabindex="0">i<span class="info-tip__bubble">Dias de carência até o cupom-filho ficar disponível para uso, contados a partir da emissão do cupom-mãe. 0 = liberado na hora.</span></span></th><th>Recorrente</th><th style="width:80px"></th></tr></thead><tbody>
              @for (c of combos(); track c.nrSequencia) { <tr><td class="num">{{ c.nrOrdem }}</td><td class="td-desc"><span class="tag">{{ c.codCupomFilho || ('Cupom #' + c.nrSeqCupomFilho) }}</span> <span class="muted">{{ c.dsCupomFilho }}</span></td><td><input type="number" min="0" class="offset-input" [ngModel]="c.nrDiasOffsetLiberacao" [ngModelOptions]="{standalone:true}" (blur)="atualizarOffsetCombo(c, $any($event.target).value)" [disabled]="salvando()" /> <span class="offset-un">d</span></td><td><span class="tag" [class.tag--sim]="c.ieRecorrente === 'S'">{{ c.ieRecorrente === 'S' ? 'Sim' : 'Nao' }}</span></td><td><button class="btn btn--sm btn--ghost-danger" (click)="excluirCombo(c.nrSequencia)" [disabled]="salvando()">Remover</button></td></tr> }
            </tbody></table>
          }
          <div class="add-section"><div class="add-row">
            <label class="fld fld--grow"><span>Buscar cupom filho</span><input type="text" [ngModel]="buscaCupomCombo()" (ngModelChange)="buscaCupomCombo.set($event)" placeholder="Codigo..." (keyup.enter)="buscarCuponsCombo()" /></label>
            <button class="btn btn--sm" (click)="buscarCuponsCombo()" [disabled]="buscaCupomCombo().length < 2">Buscar</button>
          </div>@if (resultadosBuscaCupom().length > 0 && buscaCupomCombo().length > 0) { <div class="results-box">@for (r of resultadosBuscaCupom(); track r.nrSequencia) { <div class="result-item"><span class="result-item__cod">{{ r.codCupom }}</span><span class="result-item__nome">{{ r.dsCupom }}</span><button class="btn btn--sm btn--primary" (click)="adicionarCombo(r)" [disabled]="salvando()">+</button></div> }</div> }</div>
        </section>
      }

      <section class="panel">
        <div class="panel__header"><h2 class="panel__title">Dependencias</h2><span class="panel__count">{{ dependencias().length }}</span></div>
        @if (dependencias().length === 0) { <div class="empty-state">Sem pre-requisitos.</div> } @else {
          <table class="tbl"><thead><tr><th>Cupom exigido</th><th>Tipo</th><th style="width:80px"></th></tr></thead><tbody>
            @for (d of dependencias(); track d.nrSequencia) { <tr><td class="td-desc"><span class="tag">{{ d.codCupomDep || ('Cupom #' + d.nrSeqCupomDep) }}</span> <span class="muted">{{ d.dsCupomDep }}</span></td><td>{{ d.ieTipoDep === 'U' ? 'Utilizacao' : 'Emissao' }}</td><td><button class="btn btn--sm btn--ghost-danger" (click)="excluirDependencia(d.nrSequencia)" [disabled]="salvando()">Remover</button></td></tr> }
          </tbody></table>
        }
        <div class="add-section"><div class="add-row">
          <label class="fld fld--grow"><span>Buscar cupom</span><input type="text" [ngModel]="buscaCupomDep()" (ngModelChange)="buscaCupomDep.set($event)" placeholder="Codigo..." (keyup.enter)="buscarCuponsDep()" /></label>
          <button class="btn btn--sm" (click)="buscarCuponsDep()" [disabled]="buscaCupomDep().length < 2">Buscar</button>
        </div>@if (resultadosBuscaCupomDep().length > 0 && buscaCupomDep().length > 0) { <div class="results-box">@for (r of resultadosBuscaCupomDep(); track r.nrSequencia) { <div class="result-item"><span class="result-item__cod">{{ r.codCupom }}</span><span class="result-item__nome">{{ r.dsCupom }}</span><button class="btn btn--sm btn--primary" (click)="adicionarDependencia(r)" [disabled]="salvando()">+</button></div> }</div> }</div>
      </section>

    }

    <div class="audit-footer">
      <span class="audit-footer__icon" aria-hidden="true">i</span>
      <div class="audit-footer__lines">
        @if (cupom()!.nmUsuarioNrec || cupom()!.dtAtualizacaoNrec) {
          <p><span class="audit-footer__lbl">Criado por</span> <strong>{{ cupom()!.nmPessoaCriacao || cupom()!.nmUsuarioNrec || '-' }}</strong> em {{ cupom()!.dtAtualizacaoNrec | date:'dd/MM/yyyy' }} às {{ cupom()!.dtAtualizacaoNrec | date:'HH:mm' }} (UTC-03:00)</p>
        }
        <p><span class="audit-footer__lbl">Modificado por</span> <strong>{{ cupom()!.nmPessoaModificacao || cupom()!.nmUsuario || '-' }}</strong> em {{ cupom()!.dtAtualizacao | date:'dd/MM/yyyy' }} às {{ cupom()!.dtAtualizacao | date:'HH:mm' }} (UTC-03:00)</p>
      </div>
    </div>

    @if (erro()) { <div class="alert alert--erro">{{ erro() }}</div> }
    @if (sucesso()) { <div class="alert alert--ok">{{ sucesso() }}</div> }

  }
</div>
